module.exports = __webpack_public_path__ + "static/media/stable-c.b18d9a27.png";